import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Bell } from 'lucide-react';
import { ICON } from './ui';
import { api } from '../lib/api';

/** Meldingen: één knop naar Loon controleren met een teller (verschillen + ongelezen meldingen). */
export function AfwijkingenButton() {
  const { data } = useQuery({
    queryKey: ['afwijkingen'],
    queryFn: api.afwijkingen.get,
    staleTime: 30 * 60_000,
  });
  const count = (data?.counts.verschillen ?? 0) + (data?.counts.meldingen ?? 0);
  return (
    <Link
      to="/afwijkingen"
      className="icon-btn relative"
      title="Meldingen"
      aria-label={`Meldingen${count ? ` (${count})` : ''}`}
    >
      <Bell className={ICON.md} aria-hidden />
      {count > 0 && (
        <span className="absolute right-1 top-1 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-brand-400 px-1 text-[11px] font-semibold tabular-nums text-slate-950 ring-2 ring-slate-900">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Link>
  );
}
